import React, { useEffect, useState } from "react";
import {
  getDocDataSnap,
  queryAllDocsByFieldSnap,
} from "../../../utils/firebase/Firebase.utils";
import WorkPermitCards from "../WorkPermits/WorkPermitCards";
import { slicedData } from "../../../utils/EleghoUtils";
import BentoTable from "../../../components/BentoTable";
import PageModal from "../Components/PageModal";
import WorkPermitDetails from "../WorkPermits/WorkPermitDetails";

export default function ResidentWorkPermits({ identifier }) {
  const [workPermits, setWorkPermits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [numberOfItemPerPage, setNumberOfItemPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedForView, setSelectedForView] = useState(null);
  const [viewMode, setViewMode] = useState(false);

  useEffect(() => {
    const fetchWorkPermits = async () => {
      await queryAllDocsByFieldSnap(
        "workPermits",
        "identifier",
        "==",
        identifier,
        (data) => {
          setWorkPermits(data);
          setLoading(false);
        }
      );
    };
    fetchWorkPermits();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const dataSliced = slicedData(workPermits, numberOfItemPerPage, currentPage);

  const handleViewMode = (permit) => {
    setViewMode(true);
    setSelectedForView(permit);
  };

  return (
    <div>
      <BentoTable
        label="Work Permits"
        data={dataSliced}
        numberOfItemPerPage={numberOfItemPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      >
        {workPermits.map((permit, index) => (
          <div onClick={() => handleViewMode(permit)} key={index}>
            <WorkPermitCards application={permit} />
          </div>
        ))}
      </BentoTable>

      {viewMode && (
        <PageModal>
          <WorkPermitDetails
            application={selectedForView}
            setViewMode={() => setViewMode(false)}
          />
        </PageModal>
      )}
    </div>
  );
}
